import { render, staticRenderFns } from "./component-moments.vue?vue&type=template&id=5e725241&scoped=true&"
import script from "./component-moments.vue?vue&type=script&lang=js&"
export * from "./component-moments.vue?vue&type=script&lang=js&"
import style0 from "./component-moments.vue?vue&type=style&index=0&id=5e725241&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5e725241",
  null
  
)

export default component.exports